
const ButtonTitle = ({ text }) => {
  return (
    <div className="ButtonTitle">
      <p>{text}</p>
    </div>
  );
};

export default ButtonTitle;